import { useSelector } from 'react-redux'

import { digObject } from '@domain-group/javascript-utils'

import { useForm, useLatestEntity, useThunkDispatch } from '@domain-group/react-hooks'

import * as paymentMethodActions from '@redux/modules/paymentMethod'

import defaultState, { requiredFields } from '@models/paymentMethod'

export const generateUrls = (paymentMethod = {}) => {
  const { id } = paymentMethod

  return {
    editPaymentMethodUrl: `#/systemManager/paymentMethods/${id}/edit`,
    paymentMethodsIndexUrl: '#/systemManager/paymentMethods',
  }
}

const createPaymentMethod = (params) => {
  const { paymentMethodParams, dispatch, requestOptions } = params
  const { createPaymentMethod: createFn } = paymentMethodActions

  return dispatch(createFn(paymentMethodParams, requestOptions)).then((response) => {
    const { success } = response

    if (success){
      const { data } = response
      const {
        id,
      } = data

      const { editPaymentMethodUrl } = generateUrls({ id })

      return {
        success,
        data,
        redirectUrl: editPaymentMethodUrl,
      }
    }

    return response
  })
}

const updatePaymentMethod = (params) => {
  const { paymentMethodParams, dispatch, requestOptions } = params
  const { updatePaymentMethod: updateFn } = paymentMethodActions

  return dispatch(updateFn(paymentMethodParams, requestOptions))
}

export const usePaymentMethodForm = (paymentMethod = {}, options = {}) => {
  const { validateOn } = options
  const processing_api = digObject(paymentMethod, 'data.processing_api')

  const paymentMethodForm = useForm(
    defaultState,
    {
      entity: { ...paymentMethod, processing_api },
      requiredFields,
      validateOn,
    },
    [paymentMethod.id, paymentMethod.cache_key],
  )

  return {
    ...paymentMethodForm,
  }
}

const usePaymentMethod = (initEntity = {}) => {
  const { entity: paymentMethod } = useLatestEntity(initEntity, 'paymentMethods')

  const dispatch = useThunkDispatch()

  const {
    creating, loaded, loading, updating,
  } = useSelector(reduxState => reduxState.paymentMethods)

  const processingApi = digObject(paymentMethod, 'data.processing_api', '')

  return {
    callbacks: {
      createPaymentMethod: (paymentMethodParams, requestOptions) => (
        createPaymentMethod({ paymentMethodParams, dispatch, requestOptions })
      ),
      updatePaymentMethod: (paymentMethodParams, requestOptions) => (
        updatePaymentMethod({ paymentMethodParams, dispatch, requestOptions })
      ),
    },
    creating,
    loaded,
    loading,
    paymentMethod,
    processingApi,
    updating,
    urls: generateUrls(paymentMethod),
  }
}

export default usePaymentMethod
